<template>
  <div>
    <div
      class="input-group color-picker"
      ref="colorpicker"
    >
      <span
        class="colorinput-color"
        :style="'background-color: ' + colourHexValue"
        @click="setDisplayPicker(!displayPicker)"
      />
      <chrome-picker
        v-show="displayPicker"
        :value="colors"
        @input="setColors"
      />
      <div
        :class="{'is-paused': disabled}"
      />
    </div>
  </div>
</template>

<script>
import { Chrome } from 'vue-color';

export default {
  name: 'BaseColourSelect',
  components: {
    'chrome-picker': Chrome,
  },
  props: {
    value: {
      type: [String, Object],
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      colors: {
        hex: '#000000',
      },
      displayPicker: false,
    };
  },
  computed: {
    colourHexValue() {
      return this.colors.hex;
    },
  },
  methods: {
    setDisplayPicker(isTrue) {
      if (this.disabled) return;
      if (isTrue) {
        this.$emit('focus');
        document.addEventListener('click', this.documentClick);
      } else {
        this.$emit('blur');
        document.removeEventListener('click', this.documentClick);
        if (this.colourHexValue !== this.value) this.emitColor();
      }
      this.displayPicker = isTrue;
    },
    documentClick(event) {
      const element = this.$refs.colorpicker;
      if (!element) return;
      if (element !== event.target && !element.contains(event.target)) {
        this.setDisplayPicker(false);
      }
    },
    emitColor() {
      this.$emit('input', this.colourHexValue);
      this.$emit('change');
    },
    setColors(color) {
      this.colors = color;
    },
  },
  created() {
    this.setColors({
      hex: this.value || '#000000',
    });
  },
};
</script>
<style scoped lang="scss">
.vc-chrome {
  position: absolute;
  top: 1.85rem;
  right: 0;
  z-index: 99;
}
.current-color {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: #000;
  cursor: pointer;
}
.vc-chrome-alpha-wrap{
  display: none;
}
.vc-chrome-hue-wrap{
  margin-bottom: 0;
  margin-top: 8px;
}
.vc-chrome-active-color{
    border: 1px solid #a9a9a9;
}
.is-paused {
  position: absolute;
  cursor: not-allowed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
